import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ApiService } from '../api.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';

@Component({
	selector: 'multimedia-report',
	templateUrl: './multimedia-report.component.html',
	styleUrls: ['./multimedia-report.component.scss']
})

export class MultimediaReportComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	// loading = false
	// error = false

	multimediaReportLoading = false
	multimediaReportSuccess = false
	multimediaReportError = false

	@Input() course = 0
	type = ''
	multimedia: any[] = []

	multimediaReportSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService) {}

	ngOnInit() {
		// this.loading = true
		// this.getMultimedia()
	}

	ngAfterViewInit() {}

	ngOnChanges() {
		// this.getMultimedia()
		this.multimediaReportLoading = false
		this.multimediaReportSuccess = false
		this.multimediaReportError = false
	}

	ngOnDestroy() {
		this.multimediaReportSub?.unsubscribe()
	}

	getMultimedia() {
		if (this.type == '') {
			Swal.fire('Error', 'No ha seleccionado un informe.', 'error')
			return
		}

		this.multimediaReportLoading = true
		this.multimediaReportSuccess = false
		this.multimediaReportError = false

		this.multimediaReportSub = this.dataService.multimediaReport(this.course, this.type)
		.subscribe(
			data => {
				console.log(data)
				this.multimediaReportLoading = false
				this.multimediaReportSuccess = true
				this.multimediaReportError = false
				this.multimedia = data
			},
			error => {
				console.log(error)
				this.multimediaReportLoading = false
				this.multimediaReportSuccess = false
				this.multimediaReportError = true
			},
		)
	}

}
